<template>
    <div>
        <vx-card>
            <vs-tabs v-model="activeTab">
                <vs-tab label="Reportes Ventas" v-if="userRoot || AdminFacturador">
                    <Ventas :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo" :periodoSelect="periodoSelect"/>
                </vs-tab>
                <vs-tab label="Reportes Bodega" v-if="userRoot">
                    <Bodega :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo" :periodoSelect="periodoSelect"/>
                </vs-tab>
                <vs-tab label="Reportes Facturación" v-if="userRoot || groupFacturador">
                    <Facturacion :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
                </vs-tab>
                <vs-tab label="Reportes Cobranza" v-if="userRoot || groupFacturador">
                    <Cobranza :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo" :periodoSelect="periodoSelect"/>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
    </template>

    <script>
    import {
        mapState
    } from "vuex";
    import Facturacion from "./components/reporteFacturacion.vue";
    import Bodega from "./components/reporteBodega.vue";
    import Ventas from "./components/reporteVentas.vue";
    import Cobranza from "./components/reporteCobranza.vue";

    export default {
        data() {
            return {
                activeTab:0,
            };
        },
        props:{
            periodo_id:{
                type:Number,
                default:0
            },
            nombrePeriodo:{
                type:String,
                default:''
            },
            periodoSelect:{
                type:Object,
                default:{}
            },
        },
        mounted() {},
        methods: {
        },
        //PARA DAR PERMISOS MODIFICAMOS EL Main.vue, state.js, actions.js, mutations-js
        computed: {
            ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'groupFacturador', 'userAsesor', 'AdminFacturador']),
        },
        components: {
            Facturacion,
            Bodega,
            Ventas,
            Cobranza,
        },
    };
    </script>
